import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { ChipDatas, DefaultFormData } from '../../local-types';
import { createStyles, FormControlLabel } from '@material-ui/core';

interface FormChipsProps extends DefaultFormData {
    value: number | boolean;
    options: ChipDatas[];
}

const FormChips: React.FC<FormChipsProps> = ({ value, options, hint, handleChange }) => {
    const classes = useStyles();

    const isChecked = typeof value === 'number' ? value === 1 : Boolean(value);

    return (
        <FormControl className={classes.formControl} margin="dense">
            <div className={classes.divControl}>
                {options.map(({ id, label }) => {
                    return (
                        <FormControlLabel
                            key={id}
                            id={id}
                            name={id}
                            className={classes.formControlLabel}
                            control={
                                <Chip
                                    label={label}
                                    clickable
                                    color={isChecked ? 'primary' : 'default'}
                                    onClick={handleChange}
                                />
                            }
                            label=""
                        />
                    );
                })}
            </div>
            {hint && <div className={classes.hint}>{hint}</div>}
        </FormControl>
    );
};

//======================================//
//=============== Styles ===============//
//======================================//

const useStyles = makeStyles((theme) =>
    createStyles({
        formControl: {
            flexDirection: 'column',
        },
        formControlLabel: {
            marginLeft: 8,
        },
        divControl: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap', // Permet d'ajuster les puces dans des lignes multiples si nécessaire
            gap: theme.spacing(1), // Ajoute un espace entre les puces
        },
        hint: {
            fontSize: 12,
            color: theme.palette.text.secondary,
        },
    }),
);

export default FormChips;
